import { Box, IconButton, InputAdornment } from '@mui/material';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import TextFieldController from '../TextFieldController';
import PasswordStrengthProgress from './PasswordStrengthProgress';

function PasswordFieldController({
  autoComplete,
  isSignUp = false,
  password,
  name = 'password',
  ...props
}: any) {
  const intl = useIntl();
  const [showPassword, setShowPassword] = useState(false);
  // to apply new password rules only for sign up
  const passwordLength = isSignUp ? 8 : 6;

  return (
    <>
      <TextFieldController
        name={name}
        placeholder="********"
        label={intl.formatMessage({ id: 'SETTINGS.PASSWORD.PLACEHOLDER' })}
        slotProps={{
          input: {
            type: showPassword ? 'text' : 'password',
            autoComplete: autoComplete || 'current-password',
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={intl.formatMessage({ id: 'PASSWORD_RESET.ARIA_LABEL' })}
                  onClick={() => setShowPassword(!showPassword)}
                  size="large"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
        rules={{
          required: intl.formatMessage({ id: 'AUTH.ERRORS.REQUIRED_PASSWORD' }),
          minLength: {
            value: passwordLength,
            message: intl.formatMessage(
              { id: 'AUTH.ERRORS.SHORT_PASSWORD' },
              { count: passwordLength },
            ),
          },
        }}
        {...props}
      />
      {isSignUp && (
        <Box
          sx={{
            mt: 1,
            mb: 3,
          }}
        >
          <PasswordStrengthProgress password={password} />
        </Box>
      )}
    </>
  );
}

export default PasswordFieldController;
